import { useState } from "react";
import { useNavigate , useLocation  } from "react-router-dom";
import { useOrderSummary } from "../../../../hooks/useOrderSummary";
import styles from "./prescription.module.css";

const PrescriptionPage = () => {
  const navigate = useNavigate();
const location = useLocation();

const isBuyNow = location.state?.buyNow;

const buyNowItems = isBuyNow
  ? [
      {
        product_id: location.state.product.id,
        product: location.state.product,
        quantity: location.state.quantity,
      },
    ]
  : [];

const { cartItems } = useOrderSummary();

const items = isBuyNow ? buyNowItems : cartItems;

  const [prescriptions, setPrescriptions] = useState({});

  const handleFileChange = (productId, files) => {
    const fileArray = Array.from(files);

    const formatted = fileArray.map((file) => ({
      file,
      preview: file.type.includes("image")
        ? URL.createObjectURL(file)
        : null,
    }));

    setPrescriptions((prev) => ({
      ...prev,
      [productId]: formatted,
    }));
  };

  const handleSubmit = () => {
   for (const item of items) {
      if (
        item.product?.is_prescription == 1 &&
        !prescriptions[item.product_id]
      ) {
        alert(
          `${item.product.name} requires prescription`
        );
        return;
      }
    }

    const dataToStore = {};
    const promises = [];

    Object.entries(prescriptions).forEach(
      ([productId, files]) => {
        dataToStore[productId] = [];

        files.forEach((obj) => {
          const promise = new Promise((resolve) => {
            const reader = new FileReader();

            reader.onloadend = () => {
              dataToStore[productId].push({
                name: obj.file.name,
                type: obj.file.type,
                base64: reader.result,
              });

              resolve();
            };

            reader.readAsDataURL(obj.file);
          });

          promises.push(promise);
        });
      }
    );

    Promise.all(promises).then(() => {
      localStorage.setItem(
        "productPrescriptions",
        JSON.stringify(dataToStore)
      );

      navigate("/checkout/payment" ,{
         state: location.state,
      });
    });
  };

  return (
    <div className={styles.wrapper}>
      <h2>Upload Prescription</h2>

      <p className={styles.subText}>
        Upload your doctor’s prescription to continue
        checkout
      </p>

     {items.map((item) => {
        if (item.product?.is_prescription != 1)
          return null;

        return (
          <div
            key={item.product_id}
            className={styles.productCard}
          >
            <h4>{item.product.name}</h4>

            <input
              type="file"
              multiple
              accept="image/*,.pdf"
              onChange={(e) =>
                handleFileChange(
                  item.product_id,
                  e.target.files
                )
              }
            />

            {!prescriptions[item.product_id] && (
              <div className={styles.uploadContent}>
                <div className={styles.uploadIcon}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                  >
                    <path d="M19 15v4H5v-4H3v6h18v-6zm-8-2h2V7h3l-4-5-4 5h3z" />
                  </svg>
                </div>

                <p className={styles.uploadText}>
                  Drag & drop prescription here or{" "}
                  <span>click to upload</span>
                </p>
              </div>
            )}

            <div className={styles.previewWrap}>
              {prescriptions[item.product_id]?.map(
                (img, index) => (
                  <div
                    key={index}
                    className={styles.imagePreviewCard}
                  >
                    {img.preview ? (
                      <img
                        src={img.preview}
                        alt="Prescription"
                        className={styles.previewImage}
                      />
                    ) : (
                      <p>{img.file.name}</p>
                    )}
                  </div>
                )
              )}
            </div>
          </div>
        );
      })}

      <button
        className={`${styles.continueBtn} ${
          Object.keys(prescriptions).length > 0
            ? styles.active
            : ""
        }`}
        onClick={handleSubmit}
      >
        Continue to Payment
      </button>
    </div>
  );
};

export default PrescriptionPage;